import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { bookData } from "../../Types/Types";
import { getBooks } from "../middleware/bookMiddleware";

interface bookDataState {
  loading: boolean;
  error: string | null;
  dataBook: bookData[] | null;
}

const initialState: bookDataState = {
  loading: false,
  error: null,
  dataBook: null,
};

const bookSlice = createSlice({
  name: "book",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getBooks.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getBooks.fulfilled,
        (state, action: PayloadAction<bookData[]>) => {
          state.loading = false;
          state.dataBook = action.payload;
        }
      )
      .addCase(getBooks.rejected, (state, action: PayloadAction<any>) => {
        state.error = action.payload;
      });
  },
});

export default bookSlice.reducer;
